import styled from 'styled-components';
import { space } from 'styles/variables';

export const AcknowledgeIcon = styled.span`
  display: flex;
  margin-right: ${space.x1};
`;
